import { render, staticRenderFns } from "./Information.vue?vue&type=template&id=32cf8e11&"
import script from "./Information.vue?vue&type=script&lang=js&"
export * from "./Information.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\RobertWiberg\\source\\repos\\server-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('32cf8e11')) {
      api.createRecord('32cf8e11', component.options)
    } else {
      api.reload('32cf8e11', component.options)
    }
    module.hot.accept("./Information.vue?vue&type=template&id=32cf8e11&", function () {
      api.rerender('32cf8e11', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Organisation/Information.vue"
export default component.exports